import React from "react";

import {
  Box,
  Text,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { QuickDateOption } from "../types";

type QuickDateRangeOptionProps = {
  initialQuickSelection: QuickDateOption;
  quickSelectionOption: QuickDateOption;
  isCustomRangeOpen: boolean;
  label: string;
  onPress: () => void;
};

export const QuickDateRangeOption = ({
  initialQuickSelection,
  quickSelectionOption,
  isCustomRangeOpen,
  label,
  onPress,
}: QuickDateRangeOptionProps) => {
  return (
    <Box bg="grayscale-0" px={3} py={1}>
      <Pressable
        accessibilityHint={quickSelectionOption}
        style={{ borderRadius: 4 }}
        px={3}
        py={2}
        backgroundColor={
          (initialQuickSelection === quickSelectionOption &&
            !isCustomRangeOpen) ||
          (quickSelectionOption === "Custom" && isCustomRangeOpen)
            ? "surface-status-success-subtlest"
            : "grayscale-0"
        }
        _hover={{ backgroundColor: "surface-status-success-subtlest" }}
        onPress={onPress}
      >
        <Box>
          <Text maxFontSizeMultiplier={2}>{label}</Text>
        </Box>
      </Pressable>
    </Box>
  );
};
